import { ClientSocketMessageType, createBinaryClientSocketMessage } from '@colonist/socket';
import { ClientMessageSubType } from '@colonist/types';
import * as MsgPack from '@msgpack/msgpack';
import { NetworkEnums } from '../../../../shared/GameEnums.ts';
import * as Sentry from '@sentry/browser';
export class SocketSender {
    sendToServer(subType, serverId, data, isPrimaryAction = false) {
        if (!serverId) {
            try {
                const missingRecipientError = new Error(`Direct to server message has no recipient`);
                missingRecipientError.subType = subType;
                missingRecipientError.data = data;
                throw missingRecipientError;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
                Sentry.captureException(error);
            }
            return; // no point in sending it to the router
        }
        this.send(ClientSocketMessageType.RouteToServerDirect, subType, serverId, data, isPrimaryAction);
    }
    sendToServerType(subType, serverType, data, isPrimaryAction = false) {
        this.send(ClientSocketMessageType.RouteToServerType, subType, serverType, data, isPrimaryAction);
    }
    sendNoop() {
        this.send(ClientSocketMessageType.SocketRouter, ClientMessageSubType.Noop, '', {}, false);
    }
    sendCloseSocket(closeCode) {
        const messagePayload = new Uint8Array([
            closeCode - 4000
        ]);
        const binarySocketMessage = createBinaryClientSocketMessage(ClientSocketMessageType.SocketRouter, ClientMessageSubType.CloseSocket, '', messagePayload);
        this.socket.send(binarySocketMessage);
    }
    sendPing(timestamp) {
        const returnMessage = {
            id: `${NetworkEnums.State.SocketMonitorUpdate}`,
            data: {
                timestamp: timestamp
            }
        };
        this.send(ClientSocketMessageType.SocketRouter, ClientMessageSubType.Echo, '', returnMessage, false);
    }
    onSessionEstablished() {
        this.sessionWasEstablished = true;
        for (const bufferedOutgoingMessage of this.bufferedOutgoingSecondaryMessages){
            this.socket.send(bufferedOutgoingMessage);
        }
        this.bufferedOutgoingSecondaryMessages.length = 0;
        if (this.bufferedOutgoingPrimaryMessage) {
            this.socket.send(this.bufferedOutgoingPrimaryMessage);
            this.bufferedOutgoingPrimaryMessage = undefined;
        }
    }
    send(type, subType, recipient, data, isPrimaryAction) {
        const messagePayload = MsgPack.encode(data);
        const binarySocketMessage = createBinaryClientSocketMessage(type, subType, recipient, messagePayload);
        if (!this.sessionWasEstablished) {
            if (isPrimaryAction) {
                this.bufferedOutgoingPrimaryMessage = binarySocketMessage;
            } else {
                this.bufferedOutgoingSecondaryMessages.push(binarySocketMessage);
            }
            return;
        }
        this.socket.send(binarySocketMessage);
    }
    constructor(socket, registerSessionEstablishedObserver){
        this.sessionWasEstablished = false;
        this.bufferedOutgoingSecondaryMessages = [];
        this.socket = socket;
        registerSessionEstablishedObserver(()=>this.onSessionEstablished());
    }
}
